import { render } from "./WhatsAppChatModal.vue?vue&type=template&id=dfbb3776&scoped=true"
import script from "./WhatsAppChatModal.vue?vue&type=script&lang=js"
export * from "./WhatsAppChatModal.vue?vue&type=script&lang=js"

import "./WhatsAppChatModal.vue?vue&type=style&index=0&id=dfbb3776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfbb3776"]])

export default __exports__